/**
 * Pagina editor sotto-processo attività
 * @module Pages/Admin/SottoProcessi/Editor
 */

import { useNavigate, useParams } from 'react-router-dom'
import { Button, Flex, Spinner, Text } from '../../../../Components'
import { saveSottoProcesso, useSottoProcesso } from '../Functions'
import { FloatInput } from '../../../Gigi/GigiForm/TransferField/InputForm'
import { useState } from 'react'
import { useCQuery } from '../../../../Services/QueryCache'

export function SottoProcessoEditor () {
  const { sottoProcessoId } = useParams()
  const navigate = useNavigate()
  const [sottoProcesso, setSottoProcesso, isSuccess] = useSottoProcesso(sottoProcessoId)
  const { data: processi = [], isSuccess: isSuccessProcessi } = useCQuery(['processiAttivita'])
  const [checkError, setCheckError] = useState(false)

  const save = async () => {
    setCheckError(true)
    if (!sottoProcesso?.codice) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Compila i campi obbligatori' })
      return
    }
    const res = await saveSottoProcesso(sottoProcesso)
    if (res) navigate('/admin/sottoprocessi/list')
  }

  const isNew = sottoProcessoId === 'new'

  if (!isSuccess || !sottoProcesso || !isSuccessProcessi) return <Spinner />
  return (
    <Flex fw>
      <Text value={`${isNew ? 'Crea' : 'Modifica'} Sotto-Processo`} title bold size={30} />
      <Flex fw row wrap style={{ marginTop: 20 }}>
        <Flex style={{ width: '32%', marginRight: '1%' }}>
          <FloatInput
            value={[sottoProcesso.codice || '', (val) => setSottoProcesso('codice', val)]}
            error={checkError && !sottoProcesso.codice}
            label='Codice' id='codice'
          />
        </Flex>
        <Flex style={{ width: '32%', marginRight: '1%', marginLeft: '1%' }}>
          <FloatInput
            value={[sottoProcesso.descrizione || '', (val) => setSottoProcesso('descrizione', val)]}
            label='Descrizione' id='descrizione'
          />
        </Flex>
        <Flex style={{ width: '32%', marginLeft: '1%' }}>
          <FloatInput
            type='dropdown' filter
            value={[sottoProcesso.processoId, (val) => setSottoProcesso('processoId', val)]}
            options={[
              { label: 'Nessun processo', value: null },
              ...processi.map(p => ({ label: p.descrizione || p.codice, value: p.id }))
            ]}
            label='Processo' id='processoId'
          />
        </Flex>
      </Flex>
      <Flex fw row style={{ marginTop: 30 }}>
        <Button label='Salva' icon='fa-duotone fa-check' style={{ marginRight: 10 }} onClick={save} />
        <Button label='Torna indietro' icon='fa-duotone fa-arrow-left' onClick={() => navigate('/admin/sottoprocessi/list')} />
      </Flex>
    </Flex>
  )
}

